import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { IToast } from '../../../interfaces/components/IToast';
import {
    tryToDeletePurchase,
    tryToDownloadPurchaseDetails,
    tryToFetchPurchasesAndInvoices
} from '../../../store/brokers/partner/purchases/PurchasesSlice';
import PurchaseDetailsModal from './modals/PurchaseDetailsModal';
import MismatchDetailsModal from './modals/MismatchDetailsModal';
import ConfirmDeleteModal from './modals/ConfirmDeleteModal';
import UploadFilesModal from './modals/UploadFilesModal';
import InvoiceEmailsTable from './tables/InvoiceEmailsTable';
import PurchasesTable from './tables/PurchasesTable';
import PurchaseFilters from './details/PurchaseFilters';
import Button from '../../../shared/button';
import Input from '../../../shared/input';
import Toast from '../../../shared/toast';
// import ReservationsEmails from '../reservations/tables/ReservationsEmails';


const PurchaseOrder = () => {
    const navigation = useNavigate()
    const dispatch = useAppDispatch();
    const [search, setSearch] = useState<string>();
    const [rows, setRows] = useState<Array<any>>([]);
    const [purchaseId, setPurchaseId] = useState<string>();
    const [showFileModal, setShowFileModal] = useState<boolean>(false);
    const [selectedStatus, setSelectedStatus] = useState<any>();
    const [showToast, setShowToast] = useState<IToast | null>();
    const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
    const [showMismatchModal, setShowMismatchModal] = useState<boolean>(false);
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const paginationData = useAppSelector((state) => state?.purchases?.purchaseInvoices?.data?.page);
    const purchaseLoading = useAppSelector((state) => state.purchases.purchasesInvoicesAreLoading);
    const state = useAppSelector((state) => state.purchases);

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10
        })
    }

    useEffect(() => {
        if (state.purchaseInvoices) {
            const rows = state.purchaseInvoices?.data?.elements
            setRows(rows);
        }
    }, [state.purchaseInvoices]);

    const onGettingFilters = () => {
        let data: any
        if (selectedStatus) {
            data = {
                ...data || {},
                invoiced: selectedStatus?.value === 'Yes',
            }
        }
        if (search) {
            data = {
                ...data || {},
                search: search,
            }
        }
        const formatData: any = { data: data }
        return formatData;
    }

    const onGettingPurchaseData = async () => {
        try {
            const data = onGettingFilters()
            const fetchData = {
                ...paginationState || {},
                ...data || {}
            }
            await dispatch(tryToFetchPurchasesAndInvoices(fetchData)).unwrap()
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingPurchaseData()
    }, [paginationState])

    const onClickClearAllFilter = () => {
        setSelectedStatus(undefined)
        setSearch(undefined);
        onResetPaginationState();
    }

    const onShowConfirmDelete = (id: string) => {
        document.body.style.overflow = 'hidden';
        setShowDeleteModal(true)
        setPurchaseId(id)
    }

    const onClickShowHideDelete = () => {
        setShowDeleteModal(false)
        setPurchaseId(undefined)
        setLoadingDelete(false)
        document.body.style.overflow = 'auto';
    }

    const onDeletePurchaseConfirm = async () => {
        try {
            setLoadingDelete(true)
            await dispatch(tryToDeletePurchase(purchaseId || '')).unwrap();
            setShowToast({ type: 'success', message: 'Successfully deleted' })
        } catch (err) {
            setShowToast({ type: 'error', message: `${err}` })
        }
        onClickShowHideDelete()
        setLoadingDelete(false)
    }

    const onChangeSearchValue = (value: string | null | undefined, type: string) => {
        setSearch(value || undefined)
        onResetPaginationState()
    }

    const onClickCreateOrder = () => {
        navigation('/purchase-orders/create')
    }

    const onClickEditOrder = (id: string) => {
        navigation(`/purchase-orders/edit/${id}`)
    }

    const onChangeFilterSelected = (value: any, type?: string) => {
        if (type) {
            switch (type) {
                case 'status':
                    setSelectedStatus(value)
                    break;
            }
            onResetPaginationState()
        }
    }

    const onDownloadPurchaseDetails = async (id: string) => {
        try {
            const response: any = await dispatch(tryToDownloadPurchaseDetails(id)).unwrap();
            if (response) {
                window.open(response?.excelLink, '_blank')
            }
        } catch (err) {
            setShowToast({ type: 'error', message: `${err}` })
        }
    }

    const onSeeMismatchDetails = (id: string) => {
        setPurchaseId(id)
        setShowMismatchModal(true)
        document.body.style.overflow = 'hidden';
    }

    const onSeePurchaseDetails = (id: string) => {
        setPurchaseId(id)
        setShowDetailsModal(true)
        document.body.style.overflow = 'hidden';
    }

    const onClickOpenFileModal = () => {
        setShowFileModal(true)
        document.body.style.overflow = 'hidden';
    }

    const onSaveFilesSuccessfully = () => {
        onResetPaginationState()
        onGettingPurchaseData();
    }

    const onHideDetailsModal = () => {
        setPurchaseId(undefined)
        setShowDetailsModal(false)
        setShowFileModal(false)
        setShowMismatchModal(false)
        document.body.style.overflow = 'auto';
    }
    return (
        <div>
            <div>
                <p className='page-title'>Purchases</p>
            </div>
            {/* <PurchaseFilters
                selectedStatus={selectedStatus}
                onClickFilter={onChangeFilterSelected}
            />
            <div className={`flex flex-wrap justify-between items-center mt-3 bg-[#f4f4f4] mb-2 p-1 !rounded w-full md:w-8/12`}>
                <div>
                    <Input
                        placeholder={'Filter Table'}
                        dataQa={'search'}
                        containerStyle='mb-0 pb-0 relative min-w-[500px]'
                        inputStyle={`mb-0 border-0 focus:outline-none`}
                        icon={'/assets/shared/search.svg'}
                        showValue={true}
                        inputValue={search}
                        inputUniqueName={'search'}
                        onChangeInput={onChangeSearchValue}
                        hideInputSpace={true}
                    />
                </div>
                <div className='flex flex-row justify-end space-x-4'>
                    <div className='flex flex-row justify-end ml-2'>
                        <Button
                            label='Clear Filters'
                            className={'btn-primary-text-underline min-w-auto'}
                            onClickButton={() => onClickClearAllFilter()}
                        />
                    </div>
                    <div className='col-span-2 flex flex-row justify-end'>
                        <Button
                            label={'Analyze Files'}
                            onClickButton={() => onClickOpenFileModal()}
                            className={'btn-primary !shadow-none'}
                        />
                    </div>
                </div>
            </div> */}
            <div className='flex flex-wrap'>
                <div className="w-full lg:w-8/12">
                    <PurchaseFilters
                        selectedStatus={selectedStatus}
                        onClickFilter={onChangeFilterSelected}
                    />
                    <div className={`flex flex-wrap justify-between items-center mt-3 bg-[#f3feed] mb-2 p-1 !rounded`}>
                        <div>
                            <Input
                                placeholder={'Filter Table'}
                                dataQa={'search'}
                                containerStyle='mb-0 pb-0 relative min-w-[500px]'
                                inputStyle={`mb-0 border-0 focus:outline-none`}
                                icon={'/assets/shared/search.svg'}
                                showValue={true}
                                inputValue={search}
                                inputUniqueName={'search'}
                                onChangeInput={onChangeSearchValue}
                                hideInputSpace={true}
                            />
                        </div>
                        <div className='flex flex-row justify-end space-x-4 w-full md:w-auto mt-3 md:mt-0'>
                            <div className='flex flex-row justify-end ml-2'>
                                <Button
                                    label='Clear Filters'
                                    className={'btn-primary-text-underline min-w-auto'}
                                    onClickButton={() => onClickClearAllFilter()}
                                />
                            </div>
                            <div className='col-span-2 flex flex-row justify-end'>
                                <Button
                                    label={'Analyze Files'}
                                    onClickButton={() => onClickOpenFileModal()}
                                    className={'btn-primary !shadow-none'}
                                />
                            </div>
                        </div>
                    </div>
                    <PurchasesTable
                        rows={rows}
                        rowsLoading={purchaseLoading}
                        paginationData={paginationData}
                        setPaginationState={setPaginationState}
                        onDownloadDetails={onDownloadPurchaseDetails}
                        onSeePurchaseDetails={onSeePurchaseDetails}
                        onEditPurchase={onClickEditOrder}
                        onSeeMismatchDetails={onSeeMismatchDetails}
                        onDeletePurchase={onShowConfirmDelete}
                    />
                </div>
                <div className='w-full lg:w-4/12 px-4'>
                    <InvoiceEmailsTable />
                    {/* <ReservationsEmails /> */}
                </div>
            </div>
            {showDeleteModal &&
                <ConfirmDeleteModal
                    openModal={showDeleteModal}
                    loading={loadingDelete}
                    handleCloseModal={onClickShowHideDelete}
                    onApproveAction={onDeletePurchaseConfirm}
                />
            }
            {showDetailsModal &&
                <PurchaseDetailsModal
                    openModal={showDetailsModal}
                    purchaseId={purchaseId || ''}
                    handleCloseModal={onHideDetailsModal}
                />
            }
            {showMismatchModal &&
                <MismatchDetailsModal
                    openModal={showMismatchModal}
                    purchaseId={purchaseId || ''}
                    handleCloseModal={onHideDetailsModal}
                />
            }
            {showFileModal &&
                <UploadFilesModal
                    openModal={showFileModal}
                    handleCloseModal={onHideDetailsModal}
                    onSaveFilesSuccessfully={onSaveFilesSuccessfully}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}

export default PurchaseOrder;